<template>
  <div class="home">
    <el-card shadow="always">
      <el-form :inline="true">
        <el-form-item>
          <el-input
            v-model="companyFilter"
            suffix-icon="el-icon-search"
            placeholder="Procurar por"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="isMaster" style="float: right">
          <el-button type="primary" @click="add">
            Nova Empresa
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-table
      :data="
        companyTable.filter(
          data =>
            !companyFilter ||
            data.companyName
              .toLowerCase()
              .includes(companyFilter.toLowerCase()) ||
            data.federalId.toLowerCase().includes(companyFilter.toLowerCase())
        )
      "
      height="70vh"
      style="width: 100%"
    >
      <el-table-column
        prop="companyName"
        label="Razão Social"
      ></el-table-column>
      <el-table-column
        prop="federalId"
        label="CNPJ"
        :formatter="transformCnpj"
      ></el-table-column>
      <el-table-column prop="active" label="Ativo">
        <template slot-scope="scope">{{
          scope.row.active ? "Sim" : "Não"
        }}</template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="Data Criação"
        :formatter="formatter"
      ></el-table-column>

      <el-table-column label="Usuários da Empresa">
        <template slot-scope="scope">
          <el-button size="mini" type="info" @click="loadUsers(scope.row.id)">
            <i class="el-icon-user"></i>
          </el-button>
        </template>
      </el-table-column>

      <el-table-column label="#">
        <template slot-scope="scope">
          <el-button size="mini" @click="edit(scope.row)">
            <i class="el-icon-edit"></i>
          </el-button>
          <el-button size="mini" type="danger" @click="remove(scope.row)">
            <i class="el-icon-delete"></i>
          </el-button>
          <el-button
            size="mini"
            type="warning"
            v-if="scope.row.active"
            @click="block(scope.row)"
          >
            <i class="el-icon-warning-outline"></i>
          </el-button>
          <el-button
            size="mini"
            type="success"
            v-if="!scope.row.active"
            @click="unblock(scope.row)"
          >
            <i class="el-icon-warning-outline"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="Usuários da empresa:" :visible.sync="dialogTableVisible">
      <span
        ><el-transfer
          :titles="['Usuários que não são da empresa', 'Usuários da empresa']"
          v-model="userValue"
          :data="userList"
        >
        </el-transfer>
        ></span
      >
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible = false">Cancel</el-button>
        <el-button type="primary" @click="confirmDialog()">Confirm</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { UserTypeEnum, UserService } from "../../services/users/user.services";
import { CompaniesService } from "../../services/companies/companies.service";
import moment from "moment";

export default {
  name: "CompaniesListView",
  components: {},
  data() {
    const generateData = () => {
      const data = [];
      const users = [];
      users.forEach(item => {
        data.push({
          label: item.name,
          key: item.id
        });
      });
      return data;
    };

    return {
      dialogTableVisible: false,
      companyFilter: "",
      companyTable: [],
      companyId: "",
      userList: generateData(),
      userValue: [],
      isMaster: false
    };
  },
  methods: {
    confirmDialog() {
      const vm = this;
      const loading = vm.$loading({
        lock: true,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      CompaniesService.addUsersToCompany({
        companyId: vm.companyId,
        usersId: vm.userValue
      })
        .then(() =>
          this.$message({
            type: "success",
            message: "Atualizado usuários da empresa."
          })
        )
        .catch(error => this.$message({ type: "error", message: error }))
        .finally(() => loading.close());

      vm.dialogTableVisible = false;
    },
    loadUsers(companyId) {
      const vm = this;
      const loading = vm.$loading({
        lock: true,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      UserService.list({ withCompanies: true })
        .then(response => {
          vm.userList = response.records.map(value => ({
            key: value.id,
            label: value.name
          }));
          vm.userValue = response.records
            .filter(value =>
              value.companies.some(someValue => someValue.id === companyId)
            )
            .map(value => value.id);
          this.dialogTableVisible = true;
          vm.companyId = companyId;
        })
        .catch(error => console.error(error))
        .finally(() => loading.close());
    },
    transformCnpj: function(row) {
      let cnpj = row.federalId.replace(/\D/g, "");
      cnpj = cnpj.replace(/^(\d{2})(\d)/, "$1.$2");
      cnpj = cnpj.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
      cnpj = cnpj.replace(/\.(\d{3})(\d)/, ".$1/$2");
      cnpj = cnpj.replace(/(\d{4})(\d)/, "$1-$2");
      return cnpj;
    },
    formatter(row) {
      return moment(row.createdAt).format("DD/MM/YYYY HH:mm:ss");
    },
    add: function() {
      const vm = this;
      vm.$router.push({ name: "company.add" });
    },
    edit: function(row) {
      const vm = this;
      vm.$router.replace({
        name: "company.edit",
        params: { id: row.id }
      });
    },
    remove: function(row) {
      const vm = this;
      this.$confirm(`Confirmar a eliminação da empresa ${row.name}?`, "Aviso", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancelar",
        type: "Aviso",
        center: true
      }).then(() => {
        const loading = vm.$loading({
          lock: true,
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        CompaniesService.delete(row.id)
          .then(() => {
            setTimeout(() => {
              vm.fetchRecords();
            }, 300);
            this.$message({
              type: "success",
              message: "Empresa removida com sucesso!"
            });
          })
          .catch(error => {
            vm.$notify.error({
              title: "Erro",
              message: error
            });
          })
          .finally(() => loading.close());
      });
    },
    block: function(row) {
      const vm = this;
      this.$confirm(
        `Deseja desbloquear a empresa "${
          row.companyName
        }" do CNPJ "${vm.transformCnpj(row)}"?`,
        "Aviso",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancelar",
          type: "Aviso",
          center: true
        }
      ).then(() => {
        const loading = vm.$loading({
          lock: true,
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        CompaniesService.block(row.id)
          .then(() => {
            setTimeout(() => {
              vm.fetchRecords();
            }, 500);
            this.$message({
              type: "success",
              message: "Empresa bloqueada com sucesso!"
            });
          })
          .catch(error => {
            vm.$notify.error({
              title: "Erro",
              message: error
            });
          })
          .finally(() => loading.close());
      });
    },

    unblock: function(row) {
      const vm = this;
      this.$confirm(
        `Deseja desbloquear a empresa "${
          row.companyName
        }" do CNPJ "${vm.transformCnpj(row)}"?`,
        "Aviso",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancelar",
          type: "Aviso",
          center: true
        }
      ).then(() => {
        const loading = vm.$loading({
          lock: true,
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        CompaniesService.unblock(row.id)
          .then(() => {
            setTimeout(() => {
              vm.fetchRecords();
            }, 300);
            this.$message({
              type: "success",
              message: "Empresa desbloqueada com sucesso!"
            });
          })
          .catch(error => {
            vm.$notify.error({
              title: "Erro",
              message: error
            });
          })
          .finally(() => loading.close());
      });
    },

    fetchRecords: function() {
      const vm = this;
      const loading = vm.$loading({
        lock: true,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      CompaniesService.list({})
        .then(response => (vm.companyTable = response.records))
        .catch(error => this.$message({ type: "error", message: error }))
        .finally(() => loading.close());
    }
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then(response => {
        if (
          response.user.type !== UserTypeEnum.MASTER &&
          response.user.type !== UserTypeEnum.ADMIN
        )
          return vm.$router.push({ name: "home" });
        vm.isMaster = response.user.type === UserTypeEnum.MASTER;
        vm.fetchRecords();
      })
      .catch(() => {});
  }
};
</script>
